import { and, eq, sql } from "drizzle-orm";

import type { WsBroadcastRecipient } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { db } from "@/db/db";
import { broadcastRecipient, feed } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emptyQuery } from "@/models/emptyQuery.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";
import { logQuery } from "@/models/logQuery.ts";

export const bulkUpsertBroadcastRecipients = async (broadcastRecipientRecords: WsBroadcastRecipient[]) => {
  const deduped = deduplicateByKeyValue(broadcastRecipientRecords, (item) => item.id);
  await bulkInsert(broadcastRecipient, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [broadcastRecipient.id],
      set: {
        broadcastId: sql`excluded."broadcastId"`,
        workspaceId: sql`excluded."workspaceId"`,
        feedId: sql`excluded."feedId"`,
        workspaceMembershipId: sql`excluded."workspaceMembershipId"`,
        createdAt: sql`excluded."createdAt"`,
      },
    },
  });
  emitTableUpdates(["broadcast_recipient"]);
};

export function broadcastRecipientsSelect({ broadcastId }: { broadcastId?: string }) {
  const query = db.select().from(broadcastRecipient).where(eq(broadcastRecipient.broadcastId, broadcastId));

  if (!broadcastId) {
    return emptyQuery as unknown as typeof query;
  }
  logQuery("Broadcast Recipients", query);
  return query;
}

export function broadcastRecipientsList({ workspaceId, broadcastId }: { workspaceId: string; broadcastId?: string }) {
  const whereValues = [eq(broadcastRecipient.workspaceId, workspaceId)];
  if (broadcastId) {
    whereValues.push(eq(broadcastRecipient.broadcastId, broadcastId));
  }
  const query = db
    .select({
      id: broadcastRecipient.id,
      broadcastId: broadcastRecipient.broadcastId,
      feedId: broadcastRecipient.feedId,
      title: feed.title,
    })
    .from(broadcastRecipient)
    .innerJoin(feed, eq(broadcastRecipient.feedId, feed.id))
    .where(and(...whereValues));

  if (!workspaceId) {
    return emptyQuery as unknown as typeof query;
  }
  logQuery("Broadcast Recipients", query);
  return query;
}
